import { z } from 'zod';
const ENTITY_TYPES = [
    'EVENT',
    'VENUE',
    'VENDOR',
    'USER',
    'PHOTO',
    'EXPENSE',
    'DOCUMENT',
    'VENDOR_CATEGORY',
];
export const createEntityLinkSchema = z.object({
    sourceEntityType: z.enum(ENTITY_TYPES),
    sourceEntityId: z.string().uuid(),
    targetEntityType: z.enum(ENTITY_TYPES),
    targetEntityId: z.string().uuid(),
    linkType: z.string().min(1).max(50),
    metadata: z.record(z.unknown()).optional(),
    sortOrder: z.number().int().optional(),
});
export const updateEntityLinkSchema = z.object({
    metadata: z.record(z.unknown()).optional(),
    sortOrder: z.number().int().optional(),
});
export const entityLinkQuerySchema = z.object({
    sourceEntityType: z.enum(ENTITY_TYPES).optional(),
    sourceEntityId: z.string().uuid().optional(),
    targetEntityType: z.enum(ENTITY_TYPES).optional(),
    targetEntityId: z.string().uuid().optional(),
    linkType: z.string().max(50).optional(),
});
//# sourceMappingURL=entity-link.js.map